import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Navigate, Route, Routes } from "react-router-dom";
import Login from "../salesCore/loginPage/login";
import PasswordReset from "../salesCore/passwordReset/passwordReset";
import ConfirmEmail from "../salesCore/confirmEmail/confirmEmail";
import ConfirmPasswordReset from "../salesCore/confirmPasswordReset/confirmPasswordReset";
export var PublicRoutes = function () {
    return (_jsxs(Routes, { children: [_jsx(Route, { path: "login", element: _jsx(Login, {}) }), _jsx(Route, { path: "passwordReset", element: _jsx(PasswordReset, {}) }), _jsx(Route, { path: "confirmEmail", element: _jsx(ConfirmEmail, {}) }), _jsx(Route, { path: "confirmPasswordReset", element: _jsx(ConfirmPasswordReset, {}) }), _jsx(Route, { path: "*", element: _jsx(Navigate, { to: "/login", replace: true }) })] }));
};
